angular.module('project')
    .component('projectMultiselect', {
        bindings: {
            onChange: '&',
            userProjectsFilter: '<?',
            modelType: '<',
            required: "="
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <ol class="nya-bs-select btn-sm" ng-model="$ctrl.selected" ng-change="$ctrl.onSelectionChanged()" actions-box="true" data-selected-text-format="count>2" multiple size="10" title="-- projekt --" live-search="true" ng-model-options="{ updateOn: 'blur' }">
                <li nya-bs-option="option in $ctrl.projects track by option.id" data-value="option.id" deep-watch="true">
                    <a>
                        <span>{{option.name}}</span>
                        <span class="check-mark"><i class="fa fa-thumb-tack"></i></span>
                    </a>
                </li>
            </ol>
        `,
        controller: function (Project) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.userProjectsFilter = ctrl.userProjectsFilter || false
                Project.autocomplete({userProjectsFilter: ctrl.userProjectsFilter}).$promise.then(items => {
                    ctrl.projects = formatAndMap(items)
                })

                ctrl.ngModelCtrl.$render = () => ctrl.selected = formatModelValue(ctrl.ngModelCtrl.$viewValue);
                ctrl.ngModelCtrl.$formatters.push(formatModelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? projectIds(viewValue) : viewValue);
            };

            ctrl.onSelectionChanged = () => {
                ctrl.ngModelCtrl.$setViewValue(ctrl.selected);
                ctrl.ngModelCtrl.$validate();

                ctrl.onChange({$selected: ctrl.selected});
            };

            function formatModelValue(value) {
                return ctrl.modelType === "id" ? projectIds(value) : value
            }

            function projectIds(value) {
                if (!angular.isArray(value)) {
                    value = value == null ? [] : [value]
                }
                return value
                    .map(item => angular.isObject(item) ? item.id : item)
                    .filter(id => id != null && id !== '')
            }

            function formatAndMap(items) {
                if (!angular.isArray(items)) {
                    return []
                }
                return items
                    .map(item => ({id: item.id, name: item.name}))
                    .sort((a, b) => a.name > b.name ? 1 : -1)
            }
        }
    })
